<template>
	<div class="FooterMes">Copyright 2019 由五棵松文体信息技术中心提供技术支持 联系电话：010-68291101</div>
</template>

<script>
	export default {
		name: 'FooterMes',
		props: ["fontColor"],
		data() {
			return {
				msg: '#fff',
			}
		},
		// computed:{
		// 	fontColor:function(){
		// 		return 111;
		// 	}
		// }
	}
</script>

<style scoped>
	.FooterMes {
		font-size: 12px;
		position: absolute;
		bottom: 10px;
		text-align: center;
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/FooterMes.vue